import { usePopupAlerts } from '@/v1/hooks'
import { generateErrorHTML } from '@/v1/helpers/handler'
import { FieldValues, UseFormSetError } from 'react-hook-form'

interface ErrorObject {
  type: string
  message: string
}

interface ErrorDictionary {
  [key: string]: ErrorObject
}

export const useErrorValidation = () => {
  const { sendNotification } = usePopupAlerts()

  const validateErrors = (
    errors: ErrorDictionary,
    setError?: (
      field: string,
      message: {
        type: string
        message: string
      }
    ) => UseFormSetError<FieldValues>
  ) => {
    const htmlErrors = generateErrorHTML(errors, setError)

    sendNotification('error', '', {
      html: `<div class="w-full flex justify-center space-y-1"><p class="text-sm font-normal text-red-strong text-left">${htmlErrors}</p></div>`
    })
  }

  return { validateErrors }
}
